/* eslint-disable @typescript-eslint/naming-convention */
import { post } from '@core/api/baseApi';

const updateOrganizationSettings = (settings: any): Promise<any> =>
  post('/organizations/settings', settings);

export { updateOrganizationSettings };